//====================================================
//  Function: Set image
//====================================================
function fn_components_set_image(){
	if ($( '.js-set-blog-image' ).length){
		var blogImageItem;
		var blogImageImg;
		var blogItemFirstLetter;
		var blogImageImgText;
		$('.js-set-blog-image').each(function(){
			blogImageItem = $(this);
			blogImageImg = blogImageItem.find('.blog-image-block');

			if (!blogImageImg.find('img').length){
				blogImageImgText = blogImageItem.find('.js-blog-image-text');
				blogItemFirstLetter = blogImageItem.find('.js-blog-first-letter').text().substring(0, 2);
				blogImageImgText.text(blogItemFirstLetter);
			}
		});
	}
}